import { motion } from 'framer-motion';
import styled, { css } from 'styled-components';

import { ReactComponent as EthDarkIcon } from '@pkg/components/Sections/Profile/icons/eth-dark.svg';
import { styledTypography } from '@pkg/primitives';

export const NftFloorPriceWrapper = styled.div`
    display: flex;
    align-items: center;
`;

interface StyledTypographyProp {
    $longNumber: boolean;
}

export const StyledTypography = styled.div<StyledTypographyProp>`
    ${styledTypography.allianceBase};
    font-size: 14px;
    font-weight: 600;
    letter-spacing: -0.02em;
    opacity: 0.5;
    width: calc(100% - 20px);
    margin-right: 0;
    white-space: nowrap;
    -webkit-mask-image: linear-gradient(90deg, #060b33 80%, transparent);

    ${({ $longNumber }) =>
        $longNumber &&
        css`
            width: calc(100% - 50px);
        `};
`;

export const EthWrapper = styled.div`
    position: relative;
    margin-right: 5px;
`;

export const StyledEthDarkIcon = styled(motion(EthDarkIcon))`
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
`;

export const StyledPriceWrapper = styled.div`
    display: flex;
    align-items: center;
    position: absolute;
    right: 0;
`;
